<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-08-25 09:16:21
 * @LastEditTime: 2020-11-16 14:00:48
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog :title="`${$t('lang.HangingDevice.edit')}`" :visible.sync="dialogVisible" width="30%" center>
      <div class="content">
        <el-form label-width="130px">
          <el-form-item :label="`${$t('lang.HangingDevice.printeMethod')}：`" >
            <el-select v-model="formData.printType" size="mini" clearable>
              <el-option label="socket" :value="0"></el-option>
              <el-option label="http" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.HangingDevice.vendor')}：`">
            <el-input size="mini" clearable v-model="formData.vendor"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.HangingDevice.type')}：`">
            <el-input size="mini" clearable v-model="formData.type"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button type="primary" size="mini" @click="editPrinter">{{$t('lang.Button.submit')}}</el-button>
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.Button.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updatePrinter } from '@/api/hangingDevice'
export default {
  data() {
    return {
      dialogVisible: false,
      formData: {
        id: '',
        printType: 0,
        vendor: '',
        type: ''
      }
    }
  },
  methods: {
    show(item) {
      this.formData.printType = item.printType
      this.formData.id = item.id
      this.formData.vendor = item.vendor
      this.formData.type = item.type
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
    },
    editPrinter() {
      updatePrinter(this.formData).then(res => {
        if(res.data.code === 0){
          this.$message.success(this.$t('lang.Button.successEdit'))
          this.dialogVisible = false
          this.$emit('updateList')
        }else{
          this.$message.error(this.$t('lang.Button.failEdit'))
        }
      })
    }
  },
 
}
</script>
<style scoped>
.content{
  display: flex;
  justify-content: center;
}
</style>